import { render } from "./Learndativity.vue?vue&type=template&id=7be89e1e&scoped=true"
import script from "./Learndativity.vue?vue&type=script&lang=js"
export * from "./Learndativity.vue?vue&type=script&lang=js"

import "./Learndativity.vue?vue&type=style&index=0&id=7be89e1e&scoped=true&lang=css"

import exportComponent from "/var/www/html/web-ae-pharma/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7be89e1e"]])

export default __exports__